import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const CmToMM = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToMm = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 10, 25.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const mmValue = cmValue * 10; // 1 cm = 10 mm
        setOutputValue(mmValue.toFixed(6)); // Limit output to 6 decimal places
    };






      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/mm-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to MM Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to Mm using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
            <TitleSection
              icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
              title="CM To MM Converter"
              subTitle="Effortlessly Convert CM To MM for Accurate Measurements"
            />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToMm}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>MM Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>For engineers, students, designers, and anyone working with precision measurements, the CM to MM Converter is an essential tool. It allows you to instantly convert centimeters (CM) into millimeters (MM)—a smaller metric unit used in many technical, scientific, and everyday applications.</p>
      <p>Whether you're crafting detailed designs, working in manufacturing, or simply measuring household items, this converter helps ensure accuracy at a smaller scale.</p>
      <h3>What Are CM and MM?</h3>
      <p><b>Centimeters (CM):</b><br />
      A metric unit used to measure small to moderate lengths. <br />
      1 centimeter = 10 millimeters.</p>
      <p><b>Millimeters (MM):</b><br />
      A smaller unit of length in the metric system used for precise measurements. <br />
      1 millimeter = 0.1 centimeters.</p>
      <h3>Why Convert CM to MM?</h3>
      <ul>
        <li><b>Precision:</b> Millimeters provide finer detail for accurate work, especially in engineering and design.</li>
        <li><b>Standard Practice:</b> Many tools, parts, and blueprints are dimensioned in millimeters.</li>
        <li><b>Convenience:</b> Smaller units eliminate decimals, making measurements easier to read and use in technical contexts.</li>
      </ul>
      <h3>How to Use the CM to MM Converter</h3>
      <ol>
        <li><b>Input CM Value:</b> Enter the value in centimeters.</li>
        <li><b>Click Convert:</b> The tool will instantly calculate the corresponding millimeter value.</li>
        <li><b>Use the Result:</b> Copy and apply the MM value in your design, document, or calculation.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>1 cm → 10 mm</li>
        <li>5 cm → 50 mm</li>
        <li>12.7 cm → 127 mm</li>
        <li>100 cm → 1,000 mm</li>
      </ul>
      <h3>Benefits of Using CM to MM Converter</h3>
      <ul>
        <li><b>Instant Results:</b> Converts values in a fraction of a second.</li>
        <li><b>Highly Accurate:</b> No manual calculation errors.</li>
        <li><b>Easy to Use:</b> Designed for both beginners and professionals.</li>
      </ul>
      <h3>Why Choose This CM to MM Converter?</h3>
      <p>This converter is built to make unit conversion simple and reliable, especially for fields where precision matters. Ideal for:</p>
      <ul>
        <li><b>Mechanical Engineers:</b> For technical drawings and component specifications.</li>
        <li><b>Students & Teachers:</b> For learning and classroom assignments.</li>
        <li><b>Craftspeople & DIYers:</b> For accurate measuring in projects and installations.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default CmToMM;
